import customAxios from "../index";

export const getUsersList = (params: {
    timezone?: string,
    searchText?: string,
    page?: number,
    limit?: number,
    filterByRole?: string
}) => {
    return customAxios({
        method: "GET",
        url: "/admin/user-management/users-list",
        params,
    });
};

export const updateUserStatus = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/admin/user-management/user/status",
        data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};

export const deleteUser = (userId: string | number) => {
    return customAxios({
        method: "DELETE",
        url: `/admin/user-management/user/${userId}`,
    });
};

export const sendTemporaryPassword = (data: any) => {
    return customAxios({
        method: "POST",
        url: "/admin/user-management/user/send-temp-password",
        data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};